<template>
  <h1 style="text-align: center; margin-bottom: 20px">
    {{ props.year }}年不合格环比数据汇总
  </h1>
  <div class="df df-center">
    <div class="">
      <template v-for="(data, index) in tableData" :key="index">
        <div class="df">
          <!-- 类型表格 -->
          <table class="type-table" border="1">
            <tr>
              <th rowspan="2">月份</th>
            </tr>
            <tr></tr>
            <tr v-for="(type, typeIndex) in typeList" :key="typeIndex">
              <th>{{ type }}</th>
            </tr>
          </table>

          <!-- 环比数据 -->

          <template v-for="(item, index) in data" :key="index">
            <table class="rate-table" border="1">
              <tr>
                <th colspan="2">
                  {{ item.month }}
                </th>
              </tr>

              <tr>
                <th>问题次数</th>
                <th>环比</th>
              </tr>

              <tr v-for="(type, typeIndex) in typeList" :key="typeIndex">
                <td>
                  <div :class="[item[type].anomalyNumber ? 'error' : '']">
                    {{ item[type].anomalyNumber }}
                  </div>
                </td>
                <td>
                  <div :class="[item[type].qoq ? 'error' : '']">
                    {{ item[type].qoq }}%
                  </div>
                </td>
              </tr>
            </table>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";
import { useTDArray } from "@/views/productionInstruction/server";

export default defineComponent({
  props: {
    unQualifiedQOQ: Object,
    year: String,
  },
  setup(props, context) {
    const typeList = ["物料导致", "人为导致", "半成品", "软件导致", "其他"];

    const tableData = reactive([]);

    const widthSeetings = {
      windowWidth: window.screen.width - 280,
      broadsideWidth: 160,
      tablewidth: 200,
      maxCount: 5,
    };

    // 获取渲染模板数据
    const getTempletaData = () => {
      const list = [];
      // 初始化月份
      for (let i = 1; i <= 12; i += 1) {
        const item = {
          month: i,
        };
        // 初始化类型
        typeList.forEach((key) => {
          // 初始化环比数据
          item[key] = {
            anomalyNumber: 0,
            qoq: 0,
          };
        });
        list.push(item);
      }
      return list;
    };

    // 初始化数据
    const init = () => {
      tableData.length = 0;
      const list = getTempletaData();
      const data = useTDArray(widthSeetings, list);
      tableData.push(...data);
    };

    // 赋值
    const setQOQData = (data) => {
      if (!data) return;
      tableData.length = 0;
      const list = getTempletaData();
      // 取类型数据
      Object.keys(data).forEach((key) => {
        const typeData = data[key];
        // 取月份数据
        Object.keys(typeData).forEach((month) => {
          const target = list.find((f) => f.month === Number(month));
          if (target) {
            const data = typeData[month];
            target[key].anomalyNumber = data.anomalyNumber;
            target[key].qoq = data.qoq * 100;
          }
        });
      });

      const dataList = useTDArray(widthSeetings, list);
      tableData.push(...dataList);
    };

    watch(
      () => props.unQualifiedQOQ,
      (val) => {
        console.log(val, "unQualifiedQOQ");
        init();
        if (val) {
          setQOQData(val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      typeList,
      tableData,
    };
  },
});
</script>

<style lang="less" scoped>
.rate-table {
  width: 200px;
  margin-bottom: 20px;
  border-left: none;
  .error {
    color: red;
  }
  tr > :nth-child(odd) {
    background: #e0e0e0;
  }
  tr > th {
    height: 45px;
    line-height: 45px;
    font-size: 15px;
    text-align: center;
    background: #e0e0e0;
    padding: 0 5px;
  }
  td {
    height: 45px;
    line-height: 45px;
    text-align: center;
  }
}

.type-table {
  width: 160px;
  margin-bottom: 20px;
  th {
    height: 45px;
    line-height: 45px;
    font-size: 15px;
    text-align: center;
    background: #e0e0e0;
    padding: 0 5px;
  }
  :nth-child(1) th {
    height: 129px;
  }
}
</style>
